function getOrganizationNameAcronym(organizationName: string): string {
  const arr = organizationName.split(' ');
  if (arr.length === 1) {
    return organizationName.slice(0, 2);
  }
  return arr[0][0] + arr[1][0];
}

export { getOrganizationNameAcronym };
